/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { CodeableConceptFieldsFragmentDoc, ReferenceFieldsFragmentDoc, QuantityFieldsFragmentDoc, ObservationComponentFieldsFragmentDoc, AttachmentFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListScanResultsQueryVariables = Types.Exact<{
  input: Types.ListScanResultsInput;
  is_face_or_body?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  is_cough?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  is_skin?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ListScanResultsQuery = { __typename?: 'Query', listScanResults: { __typename?: 'ListScanResultsResponse', cursor: string, hasMore: boolean, data: Array<{ __typename?: 'ScanResultModel', result_id: string, date: string, scan_type: Types.ScanType, vitall_patient_id: string, skin_lesion_location?: string | null, observations?: Array<{ __typename?: 'ObservationModel', id?: string | null, resourceType?: string | null, status: string, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null }> | null, code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null }, subject?: { __typename?: 'Reference', reference?: string | null, type?: string | null, display?: string | null, identifier?: { __typename?: 'Identifier', use?: string | null, system?: string | null, value?: string | null, type?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null } | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null } | null } | null, valueQuantity?: { __typename?: 'Quantity', value?: number | null, comparator?: string | null, unit?: string | null, system?: string | null, code?: string | null } | null, component?: Array<{ __typename?: 'ObservationComponent', valueString?: string | null, valueBoolean?: boolean | null, valueInteger?: number | null, valueDateTime?: string | null, code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null }, valueQuantity?: { __typename?: 'Quantity', value?: number | null, comparator?: string | null, unit?: string | null, system?: string | null, code?: string | null } | null, valuePeriod?: { __typename?: 'Period', start?: string | null, end?: string | null } | null } | null> | null, interpretation?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null } | null> | null }> | null, cough_results?: { __typename?: 'CoughScanResultModel', high_infection_risk: boolean, obstructive_cough_pattern: boolean, disease_likelihoods: Array<{ __typename?: 'PulmonaryDiseaseModel', disease_name: string, disease_code: string, likelihood?: number | null }> } | null, skin_results?: { __typename?: 'SkinScanResultModel', overall_risk: string, lesions: Array<{ __typename?: 'SkinLesionModel', risk: string, probability?: number | null }> } | null, attachment?: { __typename?: 'Attachment', id?: string | null, contentType?: string | null, language?: string | null, data?: string | null, url?: string | null, size?: number | null, hash?: string | null, title?: string | null, creation?: string | null } | null }> } };

export type GetScanResultQueryVariables = Types.Exact<{
  input: Types.GetScanResultInput;
}>;


export type GetScanResultQuery = { __typename?: 'Query', getScanResult: { __typename?: 'ScanResultModel', result_id: string, date: string, scan_type: Types.ScanType, vitall_patient_id: string, cough_results?: { __typename?: 'CoughScanResultModel', high_infection_risk: boolean, obstructive_cough_pattern: boolean, disease_likelihoods: Array<{ __typename?: 'PulmonaryDiseaseModel', disease_name: string, disease_code: string, likelihood?: number | null }> } | null } };

export type ListDeviceConnectionsQueryVariables = Types.Exact<{
  vitall_patient_id: Types.Scalars['String']['input'];
}>;


export type ListDeviceConnectionsQuery = { __typename?: 'Query', listScanAppConnections: Array<{ __typename?: 'ScanAppConnection', integration: string, last_updated: string }>, listTerraConnections: Array<{ __typename?: 'TerraIntegration', connection?: { __typename?: 'TerraConnection', terra_connection_id: string, vitall_patient_id: string, integration: string, last_webhook_update?: string | null, created_at?: string | null } | null }> };

export type GetScanProfileQueryVariables = Types.Exact<{
  input: Types.GetScanProfileInput;
}>;


export type GetScanProfileQuery = { __typename?: 'Query', getScanProfile: { __typename?: 'ScanProfile', patient_id: string, is_smoker?: boolean | null, is_diabetic?: boolean | null, is_hypertensive?: boolean | null, has_blood_pressure_medication?: boolean | null } };

export type UpsertScanProfileMutationVariables = Types.Exact<{
  input: Types.UpsertScanProfileInput;
}>;


export type UpsertScanProfileMutation = { __typename?: 'Mutation', upsertScanProfile: { __typename?: 'ScanProfile', patient_id: string, is_smoker?: boolean | null, is_diabetic?: boolean | null, is_hypertensive?: boolean | null, has_blood_pressure_medication?: boolean | null } };


export const ListScanResultsDocument = gql`
    query listScanResults($input: ListScanResultsInput!, $is_face_or_body: Boolean = false, $is_cough: Boolean = false, $is_skin: Boolean = false) {
  listScanResults(input: $input) {
    data {
      result_id
      date
      scan_type
      vitall_patient_id
      observations @include(if: $is_face_or_body) {
        id
        resourceType
        status
        category {
          ...CodeableConceptFields
        }
        code {
          ...CodeableConceptFields
        }
        subject {
          ...ReferenceFields
        }
        valueQuantity {
          ...QuantityFields
        }
        component {
          ...ObservationComponentFields
        }
        interpretation {
          ...CodeableConceptFields
        }
      }
      cough_results @include(if: $is_cough) {
        high_infection_risk
        obstructive_cough_pattern
        disease_likelihoods {
          disease_name
          disease_code
          likelihood
        }
      }
      skin_results @include(if: $is_skin) {
        overall_risk
        lesions {
          risk
          probability
        }
      }
      skin_lesion_location @include(if: $is_skin)
      attachment @skip(if: $is_face_or_body) {
        ...AttachmentFields
      }
    }
    cursor
    hasMore
  }
}
    ${CodeableConceptFieldsFragmentDoc}
${ReferenceFieldsFragmentDoc}
${QuantityFieldsFragmentDoc}
${ObservationComponentFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}`;
export function useListScanResultsQuery(baseOptions: Apollo.QueryHookOptions<ListScanResultsQuery, ListScanResultsQueryVariables> & ({ variables: ListScanResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScanResultsQuery, ListScanResultsQueryVariables>(ListScanResultsDocument, options);
      }
export function useListScanResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScanResultsQuery, ListScanResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScanResultsQuery, ListScanResultsQueryVariables>(ListScanResultsDocument, options);
        }
// @ts-ignore
export function useListScanResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListScanResultsQuery, ListScanResultsQueryVariables>): Apollo.UseSuspenseQueryResult<ListScanResultsQuery, ListScanResultsQueryVariables>;
export function useListScanResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListScanResultsQuery, ListScanResultsQueryVariables>): Apollo.UseSuspenseQueryResult<ListScanResultsQuery | undefined, ListScanResultsQueryVariables>;
export function useListScanResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListScanResultsQuery, ListScanResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListScanResultsQuery, ListScanResultsQueryVariables>(ListScanResultsDocument, options);
        }
export type ListScanResultsQueryHookResult = ReturnType<typeof useListScanResultsQuery>;
export type ListScanResultsLazyQueryHookResult = ReturnType<typeof useListScanResultsLazyQuery>;
export type ListScanResultsSuspenseQueryHookResult = ReturnType<typeof useListScanResultsSuspenseQuery>;
export type ListScanResultsQueryResult = Apollo.QueryResult<ListScanResultsQuery, ListScanResultsQueryVariables>;
export const GetScanResultDocument = gql`
    query getScanResult($input: GetScanResultInput!) {
  getScanResult(input: $input) {
    result_id
    date
    scan_type
    vitall_patient_id
    cough_results {
      high_infection_risk
      obstructive_cough_pattern
      disease_likelihoods {
        disease_name
        disease_code
        likelihood
      }
    }
  }
}
    `;
export function useGetScanResultQuery(baseOptions: Apollo.QueryHookOptions<GetScanResultQuery, GetScanResultQueryVariables> & ({ variables: GetScanResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanResultQuery, GetScanResultQueryVariables>(GetScanResultDocument, options);
      }
export function useGetScanResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanResultQuery, GetScanResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanResultQuery, GetScanResultQueryVariables>(GetScanResultDocument, options);
        }
// @ts-ignore
export function useGetScanResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScanResultQuery, GetScanResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetScanResultQuery, GetScanResultQueryVariables>;
export function useGetScanResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanResultQuery, GetScanResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetScanResultQuery | undefined, GetScanResultQueryVariables>;
export function useGetScanResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanResultQuery, GetScanResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanResultQuery, GetScanResultQueryVariables>(GetScanResultDocument, options);
        }
export type GetScanResultQueryHookResult = ReturnType<typeof useGetScanResultQuery>;
export type GetScanResultLazyQueryHookResult = ReturnType<typeof useGetScanResultLazyQuery>;
export type GetScanResultSuspenseQueryHookResult = ReturnType<typeof useGetScanResultSuspenseQuery>;
export type GetScanResultQueryResult = Apollo.QueryResult<GetScanResultQuery, GetScanResultQueryVariables>;
export const ListDeviceConnectionsDocument = gql`
    query listDeviceConnections($vitall_patient_id: String!) {
  listScanAppConnections(input: {vitall_patient_id: $vitall_patient_id}) {
    integration
    last_updated
  }
  listTerraConnections(input: {vitall_patient_id: $vitall_patient_id}) {
    connection {
      terra_connection_id
      vitall_patient_id
      integration
      last_webhook_update
      created_at
    }
  }
}
    `;
export function useListDeviceConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables> & ({ variables: ListDeviceConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>(ListDeviceConnectionsDocument, options);
      }
export function useListDeviceConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>(ListDeviceConnectionsDocument, options);
        }
// @ts-ignore
export function useListDeviceConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>;
export function useListDeviceConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListDeviceConnectionsQuery | undefined, ListDeviceConnectionsQueryVariables>;
export function useListDeviceConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>(ListDeviceConnectionsDocument, options);
        }
export type ListDeviceConnectionsQueryHookResult = ReturnType<typeof useListDeviceConnectionsQuery>;
export type ListDeviceConnectionsLazyQueryHookResult = ReturnType<typeof useListDeviceConnectionsLazyQuery>;
export type ListDeviceConnectionsSuspenseQueryHookResult = ReturnType<typeof useListDeviceConnectionsSuspenseQuery>;
export type ListDeviceConnectionsQueryResult = Apollo.QueryResult<ListDeviceConnectionsQuery, ListDeviceConnectionsQueryVariables>;
export const GetScanProfileDocument = gql`
    query getScanProfile($input: GetScanProfileInput!) {
  getScanProfile(input: $input) {
    patient_id
    is_smoker
    is_diabetic
    is_hypertensive
    has_blood_pressure_medication
  }
}
    `;
export function useGetScanProfileQuery(baseOptions: Apollo.QueryHookOptions<GetScanProfileQuery, GetScanProfileQueryVariables> & ({ variables: GetScanProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanProfileQuery, GetScanProfileQueryVariables>(GetScanProfileDocument, options);
      }
export function useGetScanProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanProfileQuery, GetScanProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanProfileQuery, GetScanProfileQueryVariables>(GetScanProfileDocument, options);
        }
// @ts-ignore
export function useGetScanProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScanProfileQuery, GetScanProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetScanProfileQuery, GetScanProfileQueryVariables>;
export function useGetScanProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanProfileQuery, GetScanProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetScanProfileQuery | undefined, GetScanProfileQueryVariables>;
export function useGetScanProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanProfileQuery, GetScanProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanProfileQuery, GetScanProfileQueryVariables>(GetScanProfileDocument, options);
        }
export type GetScanProfileQueryHookResult = ReturnType<typeof useGetScanProfileQuery>;
export type GetScanProfileLazyQueryHookResult = ReturnType<typeof useGetScanProfileLazyQuery>;
export type GetScanProfileSuspenseQueryHookResult = ReturnType<typeof useGetScanProfileSuspenseQuery>;
export type GetScanProfileQueryResult = Apollo.QueryResult<GetScanProfileQuery, GetScanProfileQueryVariables>;
export const UpsertScanProfileDocument = gql`
    mutation upsertScanProfile($input: UpsertScanProfileInput!) {
  upsertScanProfile(input: $input) {
    patient_id
    is_smoker
    is_diabetic
    is_hypertensive
    has_blood_pressure_medication
  }
}
    `;
export type UpsertScanProfileMutationFn = Apollo.MutationFunction<UpsertScanProfileMutation, UpsertScanProfileMutationVariables>;
export function useUpsertScanProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpsertScanProfileMutation, UpsertScanProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertScanProfileMutation, UpsertScanProfileMutationVariables>(UpsertScanProfileDocument, options);
      }
export type UpsertScanProfileMutationHookResult = ReturnType<typeof useUpsertScanProfileMutation>;
export type UpsertScanProfileMutationResult = Apollo.MutationResult<UpsertScanProfileMutation>;
export type UpsertScanProfileMutationOptions = Apollo.BaseMutationOptions<UpsertScanProfileMutation, UpsertScanProfileMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListScanResults = withQueryResponseHandler(useListScanResultsQuery);
export const useGetScanResult = withQueryResponseHandler(useGetScanResultQuery);
export const useListDeviceConnections = withQueryResponseHandler(useListDeviceConnectionsQuery);
export const useGetScanProfile = withQueryResponseHandler(useGetScanProfileQuery);
export const useUpsertScanProfile = withMutationResponseHandler(useUpsertScanProfileMutation, "upsertScanProfile");